<template lang="pug">
  .main
    h3(style="margin-bottom: 30px; text-align: center") Источники запросов на оценку рисков
    table.simpletable
      thead
        th Имя учётной записи
        th Регион учётной записи
        th МО учётной записи
        th Количество запросов
      tr(v-for="item in even(data.table.body)")
        td(style="text-align: left") {{item[0]}}
        td(style="text-align: left") {{item[1]}}
        td(style="text-align: left") {{item[2]}}
        td(style="text-align: right") {{item[3]}}
      tr
        td
        td
        td(style="text-align: left") Итого
        td(style="text-align: right") {{sum(data.table.body)}}
</template>
<script>
export default {
  props: ['data'],
  methods: {
    even: function(arr) {
      // Set slice() to avoid to generate an infinite loop!
      return arr.slice().sort(function(a, b) {
        return b[3] - a[3];
      });
    },
    sum: function(arr) {
      let sum = 0
      for (let index = 0; index < arr.length; index++) {
        sum += arr[index][3];
      }
      return sum
    }
  }
}
</script>
<style lang="sass" scoped>
.simpletable
  margin-bottom: 40px
  border-collapse: collapse
.simpletable td,
.simpletable th
  border: 1px solid #ccc
  padding: 10px
  vertical-align: middle
.simpletable thead th
  font-weight: bold
  text-align: center
table
  margin: auto
thead
  background-color: #074d59
th
  color: white
h3
  font-size: 25px
  font-weight: normal
  margin-bottom: 20px
  text-align: center
</style>
